export default {
  data() {
    return {
      load: true
    }
  },
  created() {
    document.addEventListener("readystatechange", this.initApp)
    if (document.readyState === 'complete') {
      this.load = false
    }
  },
  beforeDestroy() {
    document.removeEventListener("readystatechange", this.initApp)
  },
  methods: {
    initApp(e) {
      if (e.target.readyState === 'interactive') {
        this.load = true
      } else if (e.target.readyState === 'complete') {
        setTimeout(() => {
          this.load = false
          this.removeAnimationOnElID()
        }, 500)
      }
    },
    removeAnimationOnElID() {
      setTimeout(() => {
        const animationOnElement = document.querySelector("#animation-on")
        if(animationOnElement){
          animationOnElement.removeAttribute("id")
        }
      }, 1000)
    },
  }
}
